import { env } from 'lib/constants/env';

export const checkIsATCEnabled = (isSkincare: boolean) => {
  const atcEnabled = env.NEXT_PUBLIC_PRODUCT_CARD_ATC_ENABLED;

  return (
    atcEnabled === 'ALL' ||
    (atcEnabled === 'SKINCARE' && isSkincare) ||
    (atcEnabled === 'SUPPLEMENTS' && !isSkincare)
  );
};
